/* Mikaya — lean, fire-and-forget event tracker.
   Posts customer interactions to a Google Apps Script Sheet (settings.events_endpoint,
   injected as window.MK_EVENTS_URL). Same pattern as mk-wishlist.js: text/plain body to
   dodge the Apps Script CORS preflight, errors swallowed so tracking never breaks the page.
   No-op when the endpoint is blank. No personal data unless a customer types it into a question. */
(function () {
  function sid() {
    try {
      var s = localStorage.getItem('mk_sid');
      if (!s) { s = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem('mk_sid', s); }
      return s;
    } catch (e) { return 'nostore'; }
  }

  window.mkTrack = function (event, data) {
    var url = window.MK_EVENTS_URL;
    if (!url) return; // not configured yet — silent no-op
    var payload = {
      event: event,
      data: data || {},
      page: window.location.pathname,
      ts: new Date().toISOString(),
      sid: sid()
    };
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' }, // avoids CORS preflight to Apps Script
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  };

  /* ---------- add to cart (reuse existing mk:cart:updated event) ---------- */
  document.addEventListener('mk:cart:updated', function (e) {
    var d = (e && e.detail) || {};
    window.mkTrack('add_to_cart', { variant: d.variantId || d.variant_id || null });
  });

  /* ---------- search terms (debounced, site-wide) ---------- */
  var t;
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || el.type !== 'search') return;
    if (!el.closest('predictive-search, search-form, form[action*="/search"]')) return;
    var q = el.value.trim();
    if (q.length < 2) return;
    clearTimeout(t);
    t = setTimeout(function () { window.mkTrack('search', { q: q }); }, 800);
  });
  /* ---------- blog shop cards: view + click (see BLOG-SHOP-SYSTEM.md) ---------- */
  function shopCtx(el) {
    var card = el.closest('[data-mk-shop-card], .mk-shopend__item, [data-mk-journal-card]');
    if (!card) return null;
    return {
      module: card.hasAttribute('data-mk-shop-card') ? 'inline' : (card.hasAttribute('data-mk-journal-card') ? 'pdp_journal' : 'end_row'),
      slot: card.getAttribute('data-slot') || null,
      handle: card.getAttribute('data-handle') || null,
      page: location.pathname
    };
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a, button');
    if (!el) return;
    var c = shopCtx(el);
    if (!c) return;
    c.action = el.matches('.mk-atc, [data-mk-atc], [data-mk-variant]') ? 'atc' : 'click';
    window.mkTrack(c.module === 'pdp_journal' ? 'pdp_journal_click' : 'blog_product_' + c.action, c);
  });
  if ('IntersectionObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var c = shopCtx(en.target);
          if (c) window.mkTrack(c.module === 'pdp_journal' ? 'pdp_journal_view' : 'blog_product_view', c);
        });
      }, { threshold: 0.5 });
      document.querySelectorAll('[data-mk-shop-card], .mk-shopend__item, [data-mk-journal-card]').forEach(function (n) { io.observe(n); });
    });
  }
})();
